const formParser = (formData) => {
  let arrayNames = ['channel', 'filter', 'finish', 'trigger'];
  let regex = false;

  let filtersArray = {
    channel: [{ x: 0, y: 0, type: "", values: [] }],
    filter: [{ x: 0, y: 0, type: "", values: [] }],
    finish: [{ x: 0, y: 0, type: "", values: [] }],
    trigger: [{ x: 0, y: 0, type: "", values: [] }]
  };

  formData.map((item, index) => {
    let prop = item.name.split('-')[0];
    let name = item.name.split('-')[1];
    let value = item.value;

    if ( name === 'type' ) {
      return filtersArray[prop][0].type = value;
    }

    if (prop === 'regex' || prop === 'regex_trigger') {
      if (value === 'on') regex = true;
    }

    if (filtersArray[prop] !== undefined) {
      return filtersArray[prop][0].values.push({[name]: value});
    }
  })

  let momentumObjects = [];

  arrayNames.map((item, index) => {
    let prop = filtersArray[item][0];

    if ( prop.type === "" ) return;
    if ( prop.values.length === 0 ) return;

    let propValues = "";
    let parsedValue = "";
    let valueString = "";
    let json = "";

    if ( prop.values[0].filter !== "SUPERARE_WEBVIEW" ) {
      propValues = JSON.stringify(prop.values);
      parsedValue = propValues.replace(/[\[\]']+/gi, "").replace(/({|})+/gi, "");
      valueString = `{${parsedValue}}`;
      json = JSON.parse(valueString);
      
      if ( json.filter && json.filter === "pageview" ) {
        json.value = json.value.split(',')
      }

      if ( json.filter && json.filter === "events" ) {
        if ( json.value && json.value.length !== 0 ) {
          json.value = json.value.split(',');
        }
      }
    } else {
      propValues = JSON.parse(prop.values[1].values);
      json = {
        filter: prop.values[0].filter,
        properties: propValues
      }
    }

    if ( json.value === "Sim" ) json.value = true;
    if ( json.value === "Não" ) json.value = false;

    prop.values = [json];
 
    if (prop.type === "filter" || prop.type === "trigger") {
      prop.regex = regex;
    }

    return momentumObjects.push(prop);
  });

  return momentumObjects;
}

export default formParser;